module.exports = __webpack_public_path__ + "zendesk-1-3e4792c0b710f2bb8de77fd492a1d8d5.webp";